export default __webpack_public_path__ + "static/media/a037-n.2c2e5405.jpg";